import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "../../styles/Toast.scss";

const baseStyle = {
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  fontFamily: "'Inter', -apple-system, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  color: "#111827",
};

export const SuccessToast = ({ message }) => {
  return (
    <div style={baseStyle}>
      <i className="far fa-check-circle" style={{ fontSize: "20px", color: "#10B981", marginTop: "1px", flexShrink: 0 }}></i>
      <span>{typeof message === "string" ? message : "Successful"}</span>
    </div>
  );
};

export const ErrorToast = ({ message }) => {
  return (
    <div style={baseStyle}>
      <i className="far fa-times-circle" style={{ fontSize: "20px", color: "#EF4444", marginTop: "1px", flexShrink: 0 }}></i>
      <span>{typeof message === "string" ? message : "Please try again after sometime"}</span>
    </div>
  );
};

export const SuccessMessage = ({ message }) => {
  return (
    <div style={{ textAlign: "center", padding: "24px" }}>
      <i className="far fa-check-circle" style={{ fontSize: "56px", color: "#10B981" }}></i>
      <div style={{ marginTop: "16px", fontSize: "16px", fontWeight: 600, color: "#111827" }}>{message}</div>
    </div>
  );
};

